import { render, staticRenderFns } from "./u-btn-outlined-pill.vue?vue&type=template&id=010a4dc0&scoped=true&"
import script from "./u-btn-outlined-pill.vue?vue&type=script&lang=js&"
export * from "./u-btn-outlined-pill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010a4dc0",
  null
  
)

export default component.exports